import { render, staticRenderFns } from "./CaseFormV2.vue?vue&type=template&id=74888f4c&scoped=true"
import script from "./CaseFormV2.vue?vue&type=script&lang=js"
export * from "./CaseFormV2.vue?vue&type=script&lang=js"
import style0 from "./CaseFormV2.vue?vue&type=style&index=0&id=74888f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.8.1_vue-template-compiler@2.6.14_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74888f4c",
  null
  
)

export default component.exports